import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useLocation } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function FullMap() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const devicesParam = searchParams.getAll("devices");

  const parsedDevices = devicesParam.map((deviceString) => {
    const [deviceID, coords] = deviceString.split(":");
    const [lat, lng] = coords.split(",").map(Number);
    return { deviceID, lat, lng };
  });

  const defaultCenter = parsedDevices.length > 0 ? [parsedDevices[0].lat, parsedDevices[0].lng] : [20, 77]; // India center fallback

  const getGlowIcon = (color) => {
    return L.divIcon({
      className: "custom-glow-marker",
      html: `
        <div style="
          width: 20px;
          height: 20px;
          background-color: ${color};
          border-radius: 50%;
          border: 3px solid rgba(255, 255, 255, 0.4);
          box-shadow: 0 0 15px 6px ${color}66;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
          <div style="
            width: 10px;
            height: 10px;
            background-color: ${color};
            border-radius: 50%;
          "></div>
        </div>
      `,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
    });
  };

  const getColor = (index) => {
    const colors = ["#00c9a7", "#facc15", "#ef4444", "#fde047", "#3b82f6", "#a855f7", "#f472b6", "#22d3ee"];
    return colors[index % colors.length];
  };

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <MapContainer
        center={defaultCenter}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {parsedDevices.map((device, index) => (
          <Marker
            key={device.deviceID}
            position={[device.lat, device.lng]}
            icon={getGlowIcon(getColor(index))}
          >
            <Popup>
              <strong>{device.deviceID}</strong><br />
              Lat: {device.lat}<br />
              Lng: {device.lng}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}

export default FullMap;
